import { oPopupPadding } from 'modules/styles';
import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    flex-flow: column;
    ${oPopupPadding()};
`;
